export default __webpack_public_path__ + "static/media/img-tradable-markets.a39bab42.png";